import React from 'react';
// The following imports the components for presentation
import PhotoFrame from './PhotoFrame';
import PhotoFrameMany from './PhotoFrameMany';
import PhotoAutoplay from './PhotoAutoplay';
import SectionTitle from './SectionTitle';
import ActImagesAutoPlay from './ActImagesAutoPlay';
// import SectionText from './SectionText';

// the following imports contents to populate the textual components
import './Main.css';
// import {mainFeatureText} from '../data/mainFeature/mainFeatureText.js';
import {mainFeaturePhotoRoll} from '../data/mainFeature/mainFeaturePhotoRoll.js';
import {welcomeText} from '../data/mainFeature/mainFWelcomeText.js';
import {convenienceText} from '../data/features/convenienceText.js';
import {roomsMainText} from '../data/rooms/roomsMainText';
import {foodsMainText} from '../data/foods/foodsMainTextv2';
import {actAutoPlayImages} from '../data/activities/actAutoPlayImages';
import {activitiesMainText} from '../data/activities/activitiesMainTextv2';
import {voicesText} from '../data/voices/voices';

// Swiper add 
// the following imports images to populate the image frames (PhotoFrame and PhotoFrameMany)
import {features} from '../data/features/features.js';
import {roomType} from '../data/rooms/roomTypes1';
import {foods} from '../data/foods/foods';
// import {activities} from '../data/activities/activities';

// import images: relative path from src/assets/images directory. Don't why cannot use public/assets/images?
// import topImage from '../assets/images/mainFeature/mf-win-back.jpg';
import mintHotelsSejour from '../assets/images/mainFeature/MainPg-SejourMintFront.jpg';
import mintHotelsJunior from '../assets/images/mainFeature/MainPg-JuniorMintFront.jpg';
import feature1 from '../assets/images/features/GoryuSlope.jpg';
import feature2 from '../assets/images/features/CherryRental.jpg';
import activityImage from '../assets/images/activities/activity-image.jpg'
import feedbackImage from '../assets/images/feedback/feedbackImage.jpg'

import foods1 from '../assets/images/foods/foodRes1.jpg';
import foods2 from '../assets/images/foods/foodRes2.jpg';

import act1 from '../assets/images/activities/activities-1.jpg';
import act2 from '../assets/images/activities/activities-2.jpg';
import act3 from '../assets/images/activities/activities-3.jpg';
import act4 from '../assets/images/activities/activities-4.jpg';
import { useNavigate } from 'react-router-dom';


// This lays out the main page, including the header (navbar), footer, and everything in between
// All contents are in terms of components, with Main as the mother of components 

function Main(props) {
    const navigate = useNavigate();

    // Prepare headings for bilingual 
    // set language icon and menu items based on the language state from props.language
    var featureHeading = '', roomsHeading = '', foodHeading = '', actHeading = '', hotelSejourMint, hotelJuniorMint,
        /* galleryHeading = '', contactHeading = '', */ mintHotelsHeading = '', welcome, convenience, rooms, amenities, foodndrinks, activities, voices;
    if (props.language === 'en') {
        mintHotelsHeading = 'Hakuba Mint Group Hotels';
        hotelSejourMint = 'Hotel Sejour Mint';
        hotelJuniorMint = 'Hotel Junior Mint';
        featureHeading = 'Convenient Locations';
        roomsHeading = 'Rooms and Amenities';
        foodHeading = 'Food and Drink';
        actHeading = 'Guidance for Activities';
        // galleryHeading = 'Gallery';
        // contactHeading = 'Contact Us';
        voices = '\"Home Away From Home\"'
    } else if (props.language === 'jp') {
        mintHotelsHeading = '白馬ミントグループホテル';
        hotelSejourMint = 'ホテル　セジュールミント';
        hotelJuniorMint = 'ホテル　ジュニアミント';
        featureHeading = '便利な立地';
        roomsHeading = '部屋とアメニティー';
        foodHeading = '食べ物と飲み物';
        actHeading = 'アクテビティの案内';
        // galleryHeading = 'ギャラリー';
        // contactHeading = '問い合わせ';
        voices = '「我が家のような場所」';
    } else if (props.language === 'ch1') {
        mintHotelsHeading = '白马薄荷集团旅馆';
        hotelSejourMint = 'Hotel Sejour Mint';
        hotelJuniorMint = 'Hotel Junior Mint';
        featureHeading = '便利的位置';
        roomsHeading = '客房及附带服务';
        foodHeading = '食物和饮料';
        actHeading = '活动指导';
        // galleryHeading = '画廊';
        // contactHeading = '询问';
        voices = '家外家';
    } else if (props.language === 'ch2') {
        mintHotelsHeading = '白馬薄荷集團旅館';
        hotelSejourMint = 'Hotel Sejour Mint';
        hotelJuniorMint = 'Hotel Junior Mint';
        featureHeading = '便利的位置';
        roomsHeading = '客房及附帶服務';
        foodHeading = '食物和飲料';
        actHeading = '活動指導';
        // galleryHeading = '畫廊';
        // contactHeading = '詢問';
        voices = '家外家';
    } else {}

    // scroll to the top of the page when coming from another route
    window.scroll(0,0);

    // Welcome Text - next to three photos 
    if (props.language === 'en') {
        welcome = welcomeText.text;
        convenience = convenienceText.text;
        rooms = roomsMainText[0].text;
        amenities = roomsMainText[1].text;
        foodndrinks = foodsMainText.text;
        activities = activitiesMainText.text;
    } else if (props.language === 'jp') {
        welcome = welcomeText.textJ;
        convenience = convenienceText.textJ;
        rooms = roomsMainText[0].textJ;
        amenities = roomsMainText[1].textJ;
        foodndrinks = foodsMainText.textJ;
        activities = activitiesMainText.textJ;
    } else if (props.language === 'ch1') {
        welcome = welcomeText.textCh1;
        convenience = convenienceText.textCh1;
        rooms = roomsMainText[0].textCh1;
        amenities = roomsMainText[1].textCh1;
        foodndrinks = foodsMainText.textCh1;
        activities = activitiesMainText.textCh1;
    } else if (props.language === 'ch2') {
        welcome = welcomeText.textCh2;
        convenience = convenienceText.textCh2;
        rooms = roomsMainText[0].textCh2;
        amenities = roomsMainText[1].textCh2;
        foodndrinks = foodsMainText.textCh2;
        activities = activitiesMainText.textCh2;
    } else {};

    // Jump to rooms section: consider using react routing utility Navigator function. Current way causes pages to reload
    const jumpToRoomsSejour = () => {         
        // window.location.href = "/rooms";
        navigate('/sejour');
      }

    const jumpToActivities = () => {         
        // window.location.href = "/rooms";
        navigate('/activities');
      }

      const jumpToFoodAndDrinks = () => {         
        // window.location.href = "/rooms";
        navigate('/foods');
      }

    return (
        <div>
        { /*<div className='background'>
            <Header /> */ }

            {/* The following div is for the main image - which later may become a set of images or video clip */}
            <div className='mainFeatureImg'>
                {/* <img src={topImage} className='featureImgFrame' alt='Hotel Sejour Mint Winter 05 - import ' /> */}
                <PhotoAutoplay images={mainFeaturePhotoRoll} />
                {/* <img src='%PUBLIC_URL%/assets/images/mainFeature/mf-win-back.jpg' className='featureImgFrame' alt='Hotel Sejour Mint Winter 04' /> */}
            </div>

            {/* Group1 Feature: Hotel Welcome Section with three photos */}
            <SectionTitle ids='welcome' title={mintHotelsHeading} />
            <div className='mintGroupHotelsText'> {welcome}</div>
            <div className='mintGroupHotelsImages'>
                <div className='mintGroupHotelsImageBox' onClick={jumpToRoomsSejour}>
                    <img src={mintHotelsSejour} className='mainFeatureGroup1Image1' loading='lazy' alt='Welcome 1' />
                    <div className='mintGroupHotelsName'>{'Hotel Sejour Mint'}</div>
                </div>
                <div className='mintGroupHotelsImageBox'>
                    <img src={mintHotelsJunior} className='mainFeatureGroup1Image1' loading='lazy' alt='Welcome 2' />
                    <div className='mintGroupHotelsName'>{'Hotel Junior Mint'}</div>
            </div>
                {/* <img src='../../assets/images/mainFeature/mf-welcome1.jpg' className='mainFeatureGroup1Image1' alt='Hotel Sejour Mint Winter 2' /> */}
                {/* <div className='mainFeatureGroup1Text'> {welcome} */}
                    {/* <SectionText text={mainFeatureText} language={props.language}/> */}
                {/* </div> */}
                {/* <img loading='lazy' src={welcome2} className='mainFeatureGroup1Image2' alt='Welcome 2' /> */}
                {/* <img loading='lazy' src='../../assets/images/mainFeature/mf-welcome2.jpg' className='mainFeatureGroup1Image2' alt='Hotel Sejour Mint Winter 2' /> */}
                {/* <img loading='lazy' src={welcome3} className='mainFeatureGroup1Image3' alt='Welcome 3' /> */}
                {/* <img loading='lazy' src='../../assets/images/mainFeature/mf-welcome3.jpg' className='mainFeatureGroup1Image3' alt='Hotel Sejour Mint Winter 2' /> */}
            </div>
            <div className='sectionEnd'>{}</div>

            {/* Convenient location block */}
            <SectionTitle ids='features' title={featureHeading} />
            <div className='mintGroupHotelsText'> {convenience}</div>
            <div className='mintGroupHotelsImages'>
                <div className='mintGroupHotelsImageBox'>
                    <img src={feature1} className='mainFeatureGroup1Image1' loading='lazy' alt='Feature 1' />
                </div>
                <div className='mintGroupHotelsImageBox'>
                    <img src={feature2} className='mainFeatureGroup1Image1' loading='lazy' alt='Feature 2' />
                </div>
            </div>    
            {/* <div className='mainFeatureGroup2'>
                <div className='mainFeatureGroup2Text'> {convenience}
                </div>
                <img loading='lazy' src={feature1} className='mainFeatureGroup2Image1' alt='Feature 1' />
                <img loading='lazy' src={feature3} className='mainFeatureGroup2Image3' alt='Feature 3' />
                <img loading='lazy' src={feature2} className='mainFeatureGroup2Image2' alt='Feature 2' /> */}
                {/* <img loading='lazy' src='../../assets/images/features/f1-goryu-night.jpg' className='mainFeatureGroup2Image1' alt='Hotel Sejour Mint Winter 2' />
                <img loading='lazy' src='../../assets/images/features/f3-choukokuji.jpg' className='mainFeatureGroup2Image3' alt='Hotel Sejour Mint Winter 2' />
                <img loading='lazy' src='../../assets/images/features/f2-ski-ita.jpg' className='mainFeatureGroup2Image2' alt='Hotel Sejour Mint Winter 2' /> */}
            {/* </div> */}
            <div className='sectionEnd'>{}</div>

            {/* Restaurant Heading */}
            <SectionTitle ids='features' title={foodHeading} />
            <div className='mintGroupHotelsText'> {foodndrinks}</div>
            <div className='mintGroupHotelsImages' onClick={jumpToFoodAndDrinks} >
                <div className='mintGroupHotelsImageBox'>
                    <img src={foods1} className='mainFeatureGroup1Image1' loading='lazy' alt='Welcome 1' />
                    <div className='mintGroupHotelsName'>{'Restaurant @ Hotel Sejour Mint'}</div>
                </div>
                <div className='mintGroupHotelsImageBox'>
                    <img src={foods2} className='mainFeatureGroup1Image1' loading='lazy' alt='Welcome 2' />
                    <div className='mintGroupHotelsName'>{'Restaurant @ Hotel Junior Mint'}</div>
                </div>
            </div>

            {/* {featureImages} */}

            {/* This block is features group of photos and texts */}
            {/* <SectionTitle ids='features' title={featureHeading} />
            <div className='sectionEnd'>{featureImages}</div> */}
            {/* {featureImages} */}

            {/* This block is rendering of rooms section of the page */}
            {/* <SectionTitle ids='rooms' title={roomsHeading} />
            <div className='sectionMain'>
                <SectionText text={roomsMainText} language={props.language} />
            </div>
            <div className='sectionEnd sectionMain' >{roomsContent}</div> */} 

            {/* <SectionTitle ids='rooms' title={roomsHeading} />
            <div className='roomGroup1'>
                <img loading='lazy' src={rooms1} className='roomGroupImage1' alt='Rooms 1' onClick={jumpToRooms} />
                <div className='roomGroupText'> {rooms} </div>
                <img loading='lazy' src={rooms2} className='roomGroupImage2' alt='Rooms 2' onClick={jumpToRooms} />
                <img loading='lazy' src={rooms3} className='roomGroupImage3' alt='Rooms 3' onClick={jumpToRooms} />
            </div>
            <div className='roomGroup2'>
                <img loading='lazy' src={rooms4} className='roomGroupImage4' alt='Rooms 4' onClick={jumpToRooms} />
                <img loading='lazy' src={rooms5} className='roomGroupImage5' alt='Rooms 5' onClick={jumpToRooms} />
                <img loading='lazy' src={rooms6} className='roomGroupImage6' alt='Rooms 6' onClick={jumpToRooms} />
                <img loading='lazy' src={rooms7} className='roomGroupImage7' alt='Rooms 7' onClick={jumpToRooms} />
            </div>
            <p className='amenityText'>{amenities}</p>
            <div className='sectionEnd'>{}</div> */}


            {/* Food and Drinks section: This is the second version. Once we have determined the 
            food and drinks, esp after the bar is complete, this will be updated. For now this is
            a placeholder but with real information */}
            {/* <SectionTitle ids='foods' title={foodHeading} />
            <div className='foodGroup'>
                <img loading='lazy' src={foods1} className='foodGroupImage1' alt='Foods Dinner' onClick={jumpToFoodAndDrinks} />
                <img loading='lazy' src={foods2} className='foodGroupImage2' alt='Foods Dinning Room' onClick={jumpToFoodAndDrinks} />
                <img loading='lazy' src={foods3} className='foodGroupImage3' alt='Foods Beer' onClick={jumpToFoodAndDrinks} /> */}
                {/* <img loading='lazy' src='../../assets/images/foods/foods-dinner.jpg' className='foodGroupImage1' alt='Foods Dinner' />
                <img loading='lazy' src='../../assets/images/foods/foods-diningRm.jpg' className='foodGroupImage2' alt='Foods Dinning Room' />
                <img loading='lazy' src='../../assets/images/foods/foods-beer.jpg' className='foodGroupImage3' alt='Foods Beer' /> */}
                {/* <div className='foodGroupText'> {foodndrinks}</div>
            </div>
            <div className='sectionEnd'>{}</div> */}


            {/* This block is rendering of foods section of the page */}
            {/* <SectionTitle ids='foods' title={foodHeading} />
            <div className='sectionEnd'></div>
            <div className='sectionMain'>
                <SectionText text={foodsMainText} language={props.language} />
            </div>
            <div className='sectionEnd sectionMain'>{foodsContent}</div> */}

            {/* ZZZZZ Activities section: Intended is a continous autoplay. But not work well, jerky and not stable  */}
            {/* <SectionTitle ids='activities' title={actHeading} />
            <div className='actImagesBlock'>
                <ActImagesAutoPlay images={actAutoPlayImages} />
            </div>
            <div className='sectionEnd'>{}</div> */}

            {/* Activities section: alternative version, traditional but does the job */}
            <SectionTitle ids='activities' title={actHeading} />
            <div className='mintGroupActivityStrip' onClick={jumpToActivities} >
                <div className='mintGroupHotelsImageBox'>
                    <img src={activityImage} className='mainFeatureGroup1Image1' loading='lazy' alt='Feature 1' />
                </div>
                <div className='mintGroupHotelsImageBox'>
                    <p className='mintGroupActText'>{activities}</p>
                </div>
            </div>  
            <div className='sectionEnd'>{}</div>

            {/* // This is the activities sejour mint only version. */}
            {/* <SectionTitle ids='activities' title={actHeading} />
            <div className='activitiesMasterGroup'>
                <div className='activitiesImageGroup'>
                    <img loading='lazy' src={act1} className='activitiesImage1' alt='Act 1' />
                    <img loading='lazy' src={act2} className='activitiesImage2' alt='Act 2' />
                    <img loading='lazy' src={act3} className='activitiesImage3' alt='Act 3' />
                    <img loading='lazy' src={act4} className='activitiesImage4' alt='Act 4' /> */}
                    {/* <img loading='lazy' src='../../assets/images/activities/activities-1.jpg' className='activitiesImage1' alt='Act 1' />
                    <img loading='lazy' src='../../assets/images/activities/activities-2.jpg' className='activitiesImage2' alt='Act 2' />
                    <img loading='lazy' src='../../assets/images/activities/activities-3.jpg' className='activitiesImage3' alt='Act 3' />
                    <img loading='lazy' src='../../assets/images/activities/activities-4.jpg' className='activitiesImage4' alt='Act 4' /> */}
                {/* </div>
                <div className='activitiesText'> {activities}</div>
            </div>
            <div className='sectionEnd'>{}</div> */}

            {/* Customer voices: OLD VERSION This section lists a few samples of customer feedback  */}
            <div style={{backgroundColor: 'rgb(255, 242, 230)'}}>
                <SectionTitle ids='voices' title={voices} />
                <div className='mintGroupFeedbackStrip'>
                    <div className='mintGroupFeedbackImageBox'>
                        <img src={feedbackImage} className='mainFeatureGroup1Image1' loading='lazy' alt='Feedback' />
                    </div>
                    <div className='mintGroupFeedbackTextBox'>
                        <ul>
                            <li>"It was like a home away from home rather than a hotel." 	<b>&nbsp;&nbsp;&nbsp; Suzette, au</b></li>
                            <li>"…we felt like more than just guests, their wonderful team providing us with a warm and comfortable stay akin to a home away from home."  <b>&nbsp;&nbsp;&nbsp; Leanne, au</b>
                            </li>
                            <li>"By far the most hospitable and welcoming hotel I’ve ever stayed at." <b>&nbsp;&nbsp;&nbsp; Connor, au</b></li>
                            <li>"It is the most welcoming hotel." <b>&nbsp;&nbsp;&nbsp; Sophie, au</b></li>
                            <li>"A B&B that feels full of human touch." <b>&nbsp;&nbsp;&nbsp; Huang, tw</b></li>
                            <li>"The staff were friendly, helpful and went above and beyond in making our 1st stay in the snow in Japan a comfortable and memorable one." <b>&nbsp;&nbsp;&nbsp; Raelene, au</b></li>
                            <li>"Absolutely delighted with this find." <b>&nbsp;&nbsp;&nbsp; Lauren, gb</b></li>
                        </ul>  
                    </div>
                </div>  
                <div className='sectionEnd'>{}</div>
            </div>

            {/* Customer voices: OLD VERSION This section lists a few samples of customer feedback  */}
            {/* <div style={{backgroundColor: 'rgb(255, 242, 230)'}}>
                <SectionTitle ids='voices' title={voices} />
                <div className='voicesGroup'>

                        <div className='voiceBox'>
                            <div className='voice'>{voicesText.v1}</div>
                            <div className='voiceName'>{voicesText.v1name}</div>
                        </div>

                        <div className='voiceBox'>
                            <div className='voice'>{voicesText.v2}</div>
                            <div className='voiceName'>{voicesText.v2name}</div>
                        </div>

                        <div className='voiceBox'>
                            <div className='voice'>{voicesText.v3}</div>
                            <div className='voiceName'>{voicesText.v3name}</div>
                        </div>

                        <div className='voiceBox'>
                        <div className='voice'>{voicesText.v4}</div>
                        <div className='voiceName'>{voicesText.v4name}</div>
                        </div>

                        <div className='voiceBox'>
                            <div className='voice'>{voicesText.v5}</div>
                            <div className='voiceName'>{voicesText.v5name}</div>
                        </div>

                </div>
                <div className='sectionEnd'>{}</div>
            </div> */}

            {/* This block is rendering of activities section of the page */}
            {/* <SectionTitle ids='activities' title={actHeading} />
            <div className='sectionEnd'></div>
            <div className='sectionMain'>
                <SectionText text={activitiesMainText} language={props.language} />
            </div>
            <div className='sectionEnd sectionMain'>{activitiesContent}</div> */}

            {/* This block is rendering of  Contact Us section at the end of the page */}
            {/* <ContactUs ids='contactUs' title='Contact Us' />
            <div className='sectionEnd'></div> */}

            {/* <Footer /> */}
        </div>
    )
}

export default Main;